import React from 'react';

interface CompanyEmptyStateProps {
  searchQuery: string;
}

export const CompanyEmptyState: React.FC<CompanyEmptyStateProps> = ({ searchQuery }) => {
  return (
    <div className="px-6 py-12 text-center">
      <svg 
        className="w-16 h-16 mx-auto text-[var(--text-muted)] mb-4" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" 
        />
      </svg>
      <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">
        No companies found
      </h3>
      <p className="text-[var(--text-secondary)] mb-1">
        No companies found matching "<span className="font-medium">{searchQuery}</span>"
      </p>
      <p className="text-sm text-[var(--text-muted)]">
        Try a different search term or check your spelling
      </p>
    </div>
  );
};
